// Google Consent Mode v2 (wired up via the digitalastronaut/craft-cookie-banner
// plugin - see base.twig) only tells Google Analytics to stop reading/writing
// its cookies going forward. It never deletes cookies that were already set
// while a visitor had granted consent, so withdrawing consent alone leaves
// stale _ga/_ga_* cookies sitting in the browser until they expire on their
// own (up to 2 years). This actively removes them instead.
const COOKIES_BY_CATEGORY = {
    analyticalCookies: ['_ga', '_ga_*'],
};

function matchesPattern(cookieName, pattern) {
    if (!pattern.endsWith('*')) return cookieName === pattern;

    return cookieName.startsWith(pattern.slice(0, -1));
}

function deleteCookie(name) {
    const hostname = window.location.hostname;
    const rootDomain = hostname.split('.').slice(-2).join('.');
    // GA sets _ga/_ga_* scoped to the registrable domain (with a leading dot)
    // rather than the exact hostname, so all of these have to be tried to
    // actually clear it rather than leaving a duplicate, undeleted cookie.
    const domains = [undefined, hostname, `.${hostname}`, `.${rootDomain}`];

    domains.forEach((domain) => {
        const domainPart = domain ? `; domain=${domain}` : '';
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainPart}`;
    });
}

function removeCookiesForDeniedCategories(consent) {
    if (!consent) return;

    const existingCookieNames = document.cookie
        .split(';')
        .map((cookie) => cookie.split('=')[0].trim())
        .filter(Boolean);

    Object.entries(COOKIES_BY_CATEGORY).forEach(([category, patterns]) => {
        if (consent[category]) return;

        patterns.forEach((pattern) => {
            existingCookieNames
                .filter((cookieName) => matchesPattern(cookieName, pattern))
                .forEach(deleteCookie);
        });
    });
}

function getStoredConsent() {
    const match = document.cookie.match(/(?:^|;\s*)craft-cookie-banner=([^;]*)/);

    if (!match) return null;

    try {
        return JSON.parse(decodeURIComponent(match[1]));
    } catch {
        return null;
    }
}

// Enforce on load (covers a returning visitor whose stored consent already
// denies a category) and on every accept/refuse/save the banner dispatches.
removeCookiesForDeniedCategories(getStoredConsent());

document.addEventListener('cookie-banner:consent-update', (event) => {
    removeCookiesForDeniedCategories(event.detail.consent);
});
